import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import {
  FactCheck as DiagnosisIcon,
  MedicalServices as InterventionIcon,
  LocalHospital as NurseIcon,
} from '@mui/icons-material';
import { SESSION_MODE_OPTIONS } from '../utils/sessionMode';

const MODE_ICONS = {
  medical_diagnosis: DiagnosisIcon,
  medical_intervention: InterventionIcon,
  nurse: NurseIcon,
};

export function sessionModeHelperText(mode) {
  if (mode === 'nurse') {
    return 'Practice as a student nurse caring for the patient and communicating with a doctor using SBAR framework.';
  }
  if (mode === 'medical_diagnosis') {
    return 'Practice history, exam, investigation, and diagnosis. Stabilization, intervention, communication, and hand-off actions are not available.';
  }
  return 'Practice as a student doctor with every clinical action available, from intake through hand-off.';
}

const SessionModeToggle = ({
  value,
  onChange,
  showHelperText = true,
  size = 'medium',
  align = 'center',
  modeOptions = SESSION_MODE_OPTIONS,
  sx,
}) => {
  const handleChange = (_event, nextMode) => {
    if (nextMode !== null) {
      onChange(nextMode);
    }
  };

  const isStart = align === 'start';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isStart ? 'flex-start' : 'center',
        ...sx,
      }}
    >
      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={handleChange}
        aria-label="Simulation mode"
        size={size}
        sx={{
          bgcolor: 'background.paper',
          alignSelf: isStart ? 'stretch' : undefined,
          width: isStart ? '100%' : undefined,
          '& .MuiToggleButton-root': {
            flex: isStart ? 1 : undefined,
            px: { xs: 2, sm: 3 },
            py: 1,
            textTransform: 'none',
            fontWeight: 600,
            gap: 1,
          },
        }}
      >
        {modeOptions.map((option) => {
          const Icon = MODE_ICONS[option.value];
          return (
            <ToggleButton key={option.value} value={option.value} aria-label={option.label}>
              {Icon ? <Icon fontSize="small" /> : null}
              {option.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
      {showHelperText ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1.5, textAlign: isStart ? 'left' : 'center', maxWidth: isStart ? 'none' : 480 }}
        >
          {sessionModeHelperText(value)}
        </Typography>
      ) : null}
    </Box>
  );
};

export default SessionModeToggle;
